import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		label: {
			fontWeight: "bold"
		},
		// Page subtitle below the header
		pageSubtitle: {
			color: theme.palette.custom.textSecondary,
			marginBottom: 32,
		},
		// Section heading (top of each card)
		sectionHeading: {
			fontWeight: "bold",
			fontSize: 18,
			color: theme.palette.custom.textPrimary,
			marginBottom: 4,
		},
		// MAX-4065: subsection label inside the Display Order card ("Offices" / "Agents").
		// 16px against the card heading's 18px.
		subsectionHeading: {
			fontWeight: "bold",
			fontSize: 16,
			color: theme.palette.custom.textPrimary,
			marginBottom: 4,
		},
		// MAX-4065: the trailing "Offices page ↗" / "Team page ↗" link inside a description line.
		inlineLink: {
			display: "inline-flex",
			alignItems: "center",
			gap: 3,
			verticalAlign: "baseline",
		},
		// Description text shown before a control group
		contentDescription: {
			color: theme.palette.custom.textPrimary,
			marginBottom: 6,
		},
		// MAX-3690: 24px gap between the "Select your preferred layout…" prompt and the
		// layout option cards (dedicated so the shared contentDescription spacing is untouched).
		// The disclosed block stays flush-left with the section heading / toggle (no indent) —
		// per the design it aligns with the parent control, not the indented label text.
		bioLayoutPrompt: {
			color: theme.palette.custom.textPrimary,
			marginBottom: 24,
		},
		// Bio Pages Section Title (legacy layout)
		bioPagesSectionTitle: {
			fontWeight: 700,
			marginBottom: 16,
			fontSize: 18,
			color: "#1C1B1F",
		},
		// Enhanced Bio Toggle Label (legacy layout)
		enhancedBioLabel: {
			fontSize: 16,
			fontWeight: 700,
		},
		// Layout Selection Title (legacy layout)
		layoutSelectionTitle: {
			fontWeight: 600,
			marginBottom: 8,
			fontSize: 16,
		},
		// Layout Selection Description (legacy layout)
		layoutSelectionDescription: {
			marginBottom: 16,
			fontSize: 16,
		},
		// Layout option container
		layoutOptionsContainer: {
			display: "flex",
			gap: 24,
			flexWrap: "nowrap" as const,
			[theme.breakpoints.down("md")]: {
				flexWrap: "wrap" as const,
			},
		},
		layoutOption: {
			cursor: "pointer",
			display: "flex",
			flexDirection: "row" as const,
			alignItems: "flex-start",
		},
		// Brand orange, not the teal MUI "primary" default these fell back to (MAX-4175).
		layoutRadio: {
			padding: 0,
			color: theme.palette.custom.primary,
			"&.Mui-checked": {
				color: theme.palette.custom.primary,
			},
		},
		layoutImage: {
			objectFit: "contain",
			display: "block",
			backgroundColor: "transparent",
		},
		// Legacy styles - keeping for backwards compatibility
		layoutThumbnailWrapper: {
			cursor: "pointer",
			display: "flex",
			alignItems: "flex-start",
			gap: 12,
		},
		layout1Thumbnail: {
			borderRadius: 8,
			width: 104,
			display: "flex",
			flexDirection: "column" as const,
			gap: 4,
		},
		layout1Section1: {
			width: "100%",
			height: 37,
			backgroundColor: "#c4c4c4",
			borderRadius: 2,
		},
		layout1Section2: {
			width: "100%",
			height: 19,
			backgroundColor: "#c4c4c4",
			borderRadius: 2,
		},
		layout1Section3: {
			width: "100%",
			height: 89,
			backgroundColor: "#c4c4c4",
			borderRadius: 2,
		},
		layout2Thumbnail: {
			borderRadius: 8,
			width: 104,
			display: "flex",
			flexDirection: "column" as const,
			gap: 4,
		},
		layout2HorizontalBox: {
			width: 104,
			height: 37,
			backgroundColor: "#c4c4c4",
			borderRadius: 2,
		},
		layout2BottomContainer: {
			display: "flex",
			gap: 4,
		},
		layout2LeftBox: {
			width: 31,
			height: 112,
			backgroundColor: "#c4c4c4",
			borderRadius: 2,
		},
		layout2RightBox: {
			width: 69,
			height: 112,
			backgroundColor: "#c4c4c4",
			borderRadius: 2,
		},
	} satisfies Record<string, CSSObject>);
};